import type { ToolkitStore } from '@reduxjs/toolkit/src/configureStore';

import { utmMarksSlice } from 'entities/utmMarks';

import { getUtmMarksFromCookie } from './getUtmMarksFromCookie';
import { getUtmMarksFromQuery } from './getUtmMarksFromQuery';

export const setUtmMarksToStore = (ctx: App.ReduxAppContext['ctx'], reduxStore: ToolkitStore) => {
  reduxStore.dispatch(
    utmMarksSlice.actions.setUtmMarks({
      cookie: getUtmMarksFromCookie(ctx),
      query: getUtmMarksFromQuery(ctx),
    }),
  );
};
